function _(r,e,n){const s=r(112);class o extends s.Transform{constructor(r){super(r)}compute(r){throw new Error("mapping single values is not supported")}}n.Mapper=o,o.__name__="Mapper"}
//# sourceMappingURL=mapper.min.js.map